import React, { useEffect, useState } from "react";
import GlobalCounter from "../widget/GlobalCounter";
import WidgetAlpha from "../widget/WidgetAlpha";

const SandBox = () => {


    const [count, setCount] = useState(0)

    function increment() {
        setCount(count => count + 1)
    }

    function decrement() {
        setCount(count => count - 1)
    }

    useEffect(() => {
        console.log("Counter value:" + count)
    }, [count])

    return (
        <div>
            <div className="container bg-dark p-2 mt-2 px-4">
                <h3>Counter Locale</h3>
                <p>Click: {count}</p>
                <button type="button" onClick={decrement} className="btn bg-light">-</button>
                <span> </span>
                <button type="button" onClick={increment} className="btn bg-light">+</button>
            </div>
            <GlobalCounter/>
            <WidgetAlpha/>
        </div>

    )
}

export default SandBox